"use client";

import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { useTranslations } from "next-intl"


interface MeetingDefaults {
  duration_minutes: number;
  buffer_before_minutes: number;
  buffer_after_minutes: number;
  add_conference_link: boolean;
}

interface MeetingDefaultsConfigProps {
  value: MeetingDefaults;
  onChange: (config: MeetingDefaults) => void;
  disabled?: boolean;
}

export function MeetingDefaultsConfig({
  value,
  onChange,
  disabled,
}: MeetingDefaultsConfigProps) {
  const tUi = useTranslations("AgentTools.AgentsSharedCalendarMeetingDefaultsConfig")

  const handleChange = (updates: Partial<MeetingDefaults>) => {
    onChange({ ...value, ...updates });
  };

  return (
    <div className="space-y-4">
      {/* Duration */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <Label className="text-sm font-medium"><span key={tUi("defaultDuration")}>{tUi("defaultDuration")}</span></Label>
          <p className="text-xs text-muted-foreground">
            <span key={tUi("defaultMeetingLength")}>{tUi("defaultMeetingLength")}</span></p>
        </div>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min="15"
            max="120"
            step="15"
            value={value.duration_minutes}
            onChange={(e) =>
              handleChange({ duration_minutes: parseInt(e.target.value) || 30 })
            }
            disabled={disabled}
            className="w-20 text-sm"
          />
          <span className="text-sm text-gray-500"><span key={tUi("min")}>{tUi("min")}</span></span>
        </div>
      </div>

      {/* Buffer Times */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <Label className="text-sm font-medium"><span key={tUi("bufferTime")}>{tUi("bufferTime")}</span></Label>
          <p className="text-xs text-muted-foreground">
            <span key={tUi("gapBeforeAfterMeetings")}>{tUi("gapBeforeAfterMeetings")}</span></p>
        </div>
        <div className="flex items-center gap-2">
          <Input
            type="number"
            min="0"
            max="30"
            step="5"
            value={value.buffer_before_minutes}
            onChange={(e) =>
              handleChange({
                buffer_before_minutes: parseInt(e.target.value) || 0,
                buffer_after_minutes: parseInt(e.target.value) || 0,
              })
            }
            disabled={disabled}
            className="w-20 text-sm"
          />
          <span className="text-sm text-gray-500"><span key={tUi("min")}>{tUi("min")}</span></span>
        </div>
      </div>

      {/* Google Meet */}
      <div className="flex items-center justify-between gap-4">
        <div>
          <Label className="text-sm font-medium"><span key={"Google Meet"}>{"Google Meet"}</span></Label>
          <p className="text-xs text-muted-foreground">
            <span key={tUi("autoAddVideoConferenceLink")}>{tUi("autoAddVideoConferenceLink")}</span></p>
        </div>
        <Switch
          checked={value.add_conference_link}
          onCheckedChange={(add_conference_link) =>
            handleChange({ add_conference_link })
          }
          disabled={disabled}
        />
      </div>
    </div>
  );
}
